import { Outlet } from 'react-router-dom';
import BottomNav from '@/components/customer/BottomNav';
import { DelayedSuspense } from '@/components/DelayedSuspense';

export const CustomerLayout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-1 w-full pb-16 lg:pb-0">
        <DelayedSuspense>
          <Outlet />
        </DelayedSuspense>
      </div>
      <BottomNav />
    </div>
  );
};
